"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQueryString = void 0;
var queryString = __importStar(require("query-string"));
var use_immer_1 = require("use-immer");
var useEventListener_1 = require("../useEventListener");
function useQueryString(path) {
    var _a = use_immer_1.useImmer(queryString.parseUrl(window.location.href).query), query = _a[0], setQuery = _a[1];
    var eventListener = function (event) {
        if (window.location.pathname === path || !path) {
            setQuery(function () { return queryString.parseUrl(window.location.href).query; });
        }
    };
    useEventListener_1.useEventListener('popstate', eventListener);
    return query;
}
exports.useQueryString = useQueryString;
//# sourceMappingURL=useQueryString.web.js.map